import React, { useEffect, useState } from 'react';

//Material
import { Avatar, Box, Menu, MenuItem, Paper, Typography } from '@mui/material';

import { Stack } from '@mui/system';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ImageGallery from 'react-image-gallery';
// import { useTranslate } from 'react-redux-multilingual';
import { useSnackbar } from 'notistack';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DefaultAvatar from '../assets/defaultPostImg.jpg';
import ApiService from '../helpers/apiHelper';
import { dateFormattingByDateDot } from '../helpers/date-helpers';
import '../pages/modals/PostModal.css';
import {
  setIsOpenAuthModal,
  setIsOpenComplainModal,
  setIsOpenDeleteModal,
  setIsOpenPostModal,
  setIsOpenResendingModal,
  setUserData,
  setUserSavedPosts
} from '../redux/mainReducer';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IosShare, MoreHoriz } from '@mui/icons-material';

// import UserContactsModal from '../pages/modals/UserContactsModal';
function PostCard({
  index,
  el,
  noWidth = false,
  isInRibbon = false,
  language,
  userData,
  dataSetter,
  blockedUsers,
  usersWhoBlocked,
  commentsSwitcher,
  isChat,
  totalComments = null,
  ...props
}) {
  // const translate = useTranslate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [photos, setPhotos] = useState([]);
  // const [isLoadingPhotos, setIsLoadingPhotos] = useState(false);
  const [isWasLiked, setIsWasLiked] = useState([]);
  const [likesCount, setLikesCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const userSavedPosts = useSelector((state) => state.global.userSavedPosts);
  // const isOpenUserContactsModal = useSelector((state) => state.global.isOpenUserContactsModal);

  // const apiSavePost = new ApiService('saved-post');
  const apiSavePost = new ApiService('posts/saved-post');

  // const apiPhoto = new ApiService('get-photo');
  // const apiPhoto = new ApiService('photo/get-photo');

  const apiAddLike = new ApiService('posts/post/like');
  const post = new ApiService('posts/post');
  const apiSwitchComments = new ApiService('posts/post/switch-comment');
  const apiComplaint = new ApiService('posts/post/complaint-post');

  // const apiAddLike = new ApiService('post/like');
  // const post = new ApiService('post');
  // const apiSwitchComments = new ApiService('post/switch-comment');
  // const apiComplaint = new ApiService('post/complaint-post');

  const isHoverSelf = window.location.href.includes('post/');

  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(el?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };

  const postDelete = (id) => {
    post.deleteItem(id).then((res) => {
      if (
        window.location.href.includes('search') ||
        window.location.href.includes('user-page') ||
        window.location.href.includes('saved')
      ) {
        dataSetter(false);
        enqueueSnackbar('Пост успішно видалено', { variant: 'success' });
      }
      if (window.location.href.includes('post/')) {
        navigate(`/ua/user-page/${userData?.id}?type=posts`);
        enqueueSnackbar('Пост успішно видалено', { variant: 'success' });
      }
    });
  };
  useEffect(() => {
    setLikesCount(el.valueLikes);
    setIsWasLiked(el.isWasLiked);
    // eslint-disable-next-line
    return () => {
      setLikesCount(0);
      setIsWasLiked(false);
    };
    // eslint-disable-next-line
  }, [el]);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const postDeleteOut = () => {
    dispatch(
      setIsOpenDeleteModal({ isOpen: true, text: 'цей пост?', func: postDelete, id: el.id })
    );
  };
  useEffect(() => {
    let mounted = true;
    const getPhotos = async () => {
      if (!isChat) {
        setPhotos([...el?.photoUrls]);
      } else {
        setPhotos([el?.photoUrls[0]]);
      }
    };
    if (el?.photoUrls && el?.photoUrls.length !== 0 && mounted) {
      getPhotos();
    } else {
      setPhotos([]);
    }
    return () => (mounted = false);
    // eslint-disable-next-line
  }, []);

  return (
    <Paper
      // {...props}
      key={index}
      // className="postCard"
      sx={{
        position: 'relative',
        width: { xs: isChat ? '250px' : '100%', sm: isChat ? '270px' : '100%' },
        maxWidth: {
          xs: isChat ? '270px' : 'unset',
          sm: window.location?.href.includes('ribbon') ? '600px' : '700px'
        },
        height: 'unset',
        // margin: '0px 0.5%',
        textAlign: 'center',
        backgroundColor: 'white',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        // : 'none',
        borderRadius: '4px',
        padding: { xs: '8px', sm: isChat || isInRibbon ? '8px' : '24px', md: '24px' },
        overflow: 'hidden'
        // '&:hover':
        //   isHoverMy || isHoverSearch || isHoverSelf || isHoverSaved
        //     ? {}
        //     : { boxShadow: '-10px 10px 3px black', transform: 'scale(1.025)', transition: 'all 1s' }
      }}
    >
      {el?.isBlocked ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
            justifyContent: 'start',
            width: 'calc(100% + 4px)',
            height: 'calc(100% + 4px)',
            position: 'absolute',
            backgroundColor: 'rgba(124, 124, 124, 0.40)',
            top: -1,
            right: -1,
            zIndex: 100
          }}
        />
      ) : null}
      <Stack
        spacing={2}
        direction="column"
        justifyContent="space-between"
        style={{ padding: '0', height: '100%' }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{ alignItems: 'center' }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', padding: { xs: '8px 0px', sm: '8px' } }}
          >
            <Avatar
              onClick={() => {
                if (!el?.userRibbonDTO) {
                  if (userData?.id) {
                    navigate(`/${language}/user-page/${el.userDTO.id}?type=posts`);
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                } else {
                  if (userData?.id) {
                    navigate(`/${language}/user-page/${el.userRibbonDTO.id}?type=posts`);
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }
              }}
              alt="avatar"
              src={
                (el?.userDTO && el?.userDTO?.photoUrl) ||
                (el?.userRibbonDTO && el?.userRibbonDTO?.photoUrl)
                  ? `${el?.userDTO ? el.userDTO?.photoUrl : el.userRibbonDTO?.photoUrl}`
                  : DefaultAvatar
              }
              sx={{
                width: {
                  xs: isChat || isInRibbon ? 40 : 60,
                  sm: isChat || isInRibbon ? 40 : 80,
                  md: 80
                },
                height: {
                  xs: isChat || isInRibbon ? 40 : 60,
                  sm: isChat || isInRibbon ? 40 : 80,
                  md: 80
                },
                border: 'none',
                mr: { xs: '8px', sm: isChat ? '8px' : '24px' },
                cursor: 'pointer',
                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                // boxShadow: blockedUsers.find(
                //   (user) => user.id === el?.userDTO?.id || user.id === el?.userRibbonDTO?.id
                // )
                //   ? '0px 0px 2px 2px rgba(255,0,0,1)'
                //   : 'none'
              }}
            />
            <Stack sx={{ maxWidth: '490px' }}>
              <Typography
                onClick={() => {
                  if (!el?.userRibbonDTO) {
                    if (userData?.id) {
                      navigate(`/${language}/user-page/${el.userDTO.id}?type=posts`);
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  } else {
                    if (userData?.id) {
                      navigate(`/${language}/user-page/${el.userRibbonDTO.id}?type=posts`);
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  }
                }}
                component="p"
                fontWeight={400}
                sx={{
                  wordBreak: 'break-all',
                  textAlign: 'left',
                  fontSize: { xs: '14px', sm: isChat || isInRibbon ? '14px' : '16px' },
                  cursor: 'pointer',
                  lineHeight: '16px',
                  color: '#7C7C7C'
                }}
              >
                {`@${el?.userDTO ? el?.userDTO?.nickname : el.userRibbonDTO?.nickname}`}
                {!isChat && ' • '}
                {!isChat && dateFormattingByDateDot(new Date(el.creationTimeForPost))}
              </Typography>
              {(el?.userDTO && el?.userDTO?.name && el?.userDTO?.surname) ||
              (el?.userRibbonDTO && el.userRibbonDTO?.name && el.userRibbonDTO?.surname) ? (
                <Typography
                  fontWeight={500}
                  sx={{
                    cursor: 'pointer',
                    textAlign: 'left',
                    lineHeight: isChat || isInRibbon ? '22px' : '30px',
                    fontSize: { xs: '16px', sm: isChat || isInRibbon ? '16px' : '20px' }
                  }}
                  onClick={() => {
                    if (!el?.userRibbonDTO) {
                      if (userData?.id) {
                        navigate(`/${language}/user-page/${el.userDTO.id}?type=posts`);
                      } else {
                        dispatch(setIsOpenAuthModal(true));
                      }
                    } else {
                      if (userData?.id) {
                        navigate(`/${language}/user-page/${el.userRibbonDTO.id}?type=posts`);
                      } else {
                        dispatch(setIsOpenAuthModal(true));
                      }
                    }
                  }}
                >
                  {`${el?.userDTO ? el?.userDTO?.name : el.userRibbonDTO?.name}`}
                  <br />
                  {`${el?.userDTO ? el?.userDTO?.surname : el.userRibbonDTO?.surname}`}
                </Typography>
              ) : null}
            </Stack>
            {userData?.id && (
              <Box
                id="positioned-button"
                onClick={(event) => handleClick(event)}
                sx={{
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: { xs: '30px', sm: isChat || isInRibbon ? '30px' : '40px' },
                  height: { xs: '30px', sm: isChat || isInRibbon ? '30px' : '40px' },
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                  borderRadius: '50px',
                  right: { xs: '8px', sm: isChat || isInRibbon ? '8px' : '24px' },
                  zIndex: 102
                }}
              >
                {el?.isBlocked && (
                  <Box
                    sx={{
                      width: 'fit-content',
                      backgroundColor: '#FFE5E5',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      color: '#F64D36',
                      fontSize: '20px',
                      position: 'absolute',
                      right: { xs: '50px', sm: '60px' }
                      // left: '4px'
                    }}
                  >
                    Заблоковано
                  </Box>
                )}
                <MoreHoriz sx={{ cursor: 'pointer' }} />
              </Box>
            )}
          </Box>

          <Menu
            anchorEl={anchorEl}
            id="action-menu"
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'hidden',
                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                borderRadius: '4px',
                border: 'none',
                paddingTop: '10px',
                paddingLeft: '20px',
                paddingRight: '20px',
                width: '283px',
                mt: 1
              }
            }}
            autoFocus={false}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {(!window.location.href.includes('post') ||
              window.location.href.includes('messages')) && (
              <MenuItem
                sx={{
                  borderRadius: '4px',
                  '&.MuiMenuItem-root:hover': { backgroundColor: '#E2F2FF' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  pl: '12px !important',
                  m: '2px 0px !important'
                }}
                onClick={() => {
                  handleClose();
                  if (userData?.id) {
                    if (!el?.isBlocked) {
                      window.open(`${window.location.origin}/${language}/post/${el.id}`);
                    }
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
              >
                Сторінка посту
              </MenuItem>
            )}

            {el?.userDTO?.id === userData?.id &&
              !el?.isBlocked &&
              !window.location.href.includes('messages') && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#E2F2FF' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    handleClose();
                    dispatch(setIsOpenPostModal({ isOpen: true, func: dataSetter, data: el }));
                  }}
                >
                  Редагувати
                </MenuItem>
              )}
            {el?.userDTO?.id === userData?.id &&
              !el?.isBlocked &&
              !window.location.href.includes('messages') && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#E2F2FF' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    apiSwitchComments
                      .updateDataQueryId(el?.id, {
                        isPossibleWriteCommentsToPost: el?.turnOnComments ? false : true
                      })
                      .then((res) => {
                        if (window.location.href.includes('post/')) {
                          commentsSwitcher();
                          handleClose();
                        } else if (window.location.href.includes('search')) {
                          dataSetter(el?.id);
                          handleClose();
                        } else {
                          dataSetter(false);
                          handleClose();
                        }
                      })
                      .catch((error) => console.error(error));
                  }}
                >
                  {el?.turnOnComments ? 'Вимкнути коментарі' : 'Увімкнути коментарі'}
                </MenuItem>
              )}
            {!window.location.href.includes('messages') && (
              <MenuItem
                sx={{
                  borderRadius: '4px',
                  ':hover': { backgroundColor: '#E2F2FF' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  pl: '12px !important',
                  m: '2px 0px !important'
                }}
                onClick={() => {
                  handleClose();
                  dispatch(setIsOpenResendingModal({ isOpen: true, id: el.id, type: 'post' }));
                }}
              >
                Відправити у повідомлення
              </MenuItem>
            )}
            {!window.location.href.includes('messages') && (
              <MenuItem
                sx={{
                  borderRadius: '4px',
                  ':hover': { backgroundColor: '#E2F2FF' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  pl: '12px !important',
                  m: '2px 0px !important'
                }}
                onClick={() => {
                  navigator.clipboard.writeText(`${window.location.origin}/ua/post/${el?.id}`);
                  handleClose();
                  enqueueSnackbar('Посилання на пост скопійовано', { variant: 'success' });
                }}
              >
                Скопіювати посилання
              </MenuItem>
            )}

            {el?.userDTO?.id === userData?.id &&
              !el?.isBlocked &&
              !window.location.href.includes('messages') && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#FFE5E5' },

                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    color: '#F64D36',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    if (window.location.href.includes('user-page')) {
                      handleClose();
                      dispatch(
                        setIsOpenDeleteModal({
                          isOpen: true,
                          text: 'цей пост?',
                          func: postDelete,
                          id: el.id
                        })
                      );
                    } else {
                      postDeleteOut();
                      handleClose();
                    }
                  }}
                >
                  Видалити пост
                </MenuItem>
              )}

            {userData?.id &&
              el?.userDTO?.id !== userData?.id &&
              !window.location.href.includes('messages') && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#FFE5E5' },

                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    color: '#F64D36',

                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    dispatch(setIsOpenComplainModal({ isOpen: true, func: sendComplaint }));
                    handleClose();
                  }}
                >
                  <Typography
                    component="p"
                    fontSize={16}
                    sx={{ lineHeight: '18px' }}
                    fontWeight={400}
                  >
                    Поскаржитись
                  </Typography>
                </MenuItem>
              )}
          </Menu>
        </Stack>

        {/* {el?.encodedContent.length!==0&& el?.encodedContent.length===1&&<></>} */}
        {/* {isLoadingPhotos && el.encodedPhotos.length === 1 && (
          <Skeleton sx={{ height: 679, mt: '40px' }} animation="wave" variant="rectangular" />
        )} */}

        {el !== null && el && el?.photoUrls && el?.photoUrls.length !== 0 && photos.length !== 0 ? (
          <ImageGallery
            infinite={true}
            style={{ marginTop: 0 }}
            showPlayButton={false}
            showBullets={false}
            showThumbnails={photos.length > 1}
            showFullscreenButton={false}
            renderLeftNav={(onClick) => (
              <div
                onClick={onClick}
                style={{
                  display: 'flex',
                  width: '40px',
                  height: '40px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: 'calc(50% - 15px)',
                  left: '5px',
                  zIndex: 99,
                  backgroundColor: 'rgba(255, 255, 255, 0.80)',
                  borderRadius: '50px',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <ArrowBackIosIcon
                  sx={{
                    color: 'black',
                    fontSize: '24px',
                    cursor: 'pointer',
                    ml: '8px'
                  }}
                />
              </div>
            )}
            renderRightNav={(onClick) => (
              <div
                onClick={onClick}
                style={{
                  display: 'flex',
                  width: '40px',
                  height: '40px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: 'calc(50% - 15px)',
                  right: '5px',
                  zIndex: 99,
                  backgroundColor: 'rgba(255, 255, 255, 0.80)',
                  borderRadius: '50px',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <ArrowForwardIosIcon
                  sx={{
                    color: 'black',
                    fontSize: '24px',
                    cursor: 'pointer'
                  }}
                />
              </div>
            )}
            items={photos.map((photo) => {
              return {
                original: photo,
                thumbnail: photo,
                originalHeight: 652,
                originalWidth: 652,
                thumbnailHeight: 652,
                originalClass: 'service-photo-slide',
                thumbnailClass: 'thumbnailSlide'
              };
            })}
          />
        ) : null}
        {/* {el.photoUrls.length > 1 && isLoadingPhotos && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Skeleton
              sx={{ height: 679, width: '100%', borderRadius: '5px' }}
              animation="wave"
              variant="rectangular"
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 2, maxWidth: '100%' }}>
              {el.photoUrls.map((photo, index) => (
                <Skeleton
                  sx={{ height: 95, width: 95, ml: index !== 0 ? 1 : 0 }}
                  animation="wave"
                  variant="rectangular"
                />
              ))}
            </Box>
          </Box>
        )} */}

        <Stack direction="column" justifyContent="space-between" sx={{ mt: '24px !important' }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: isInRibbon ? '14px !important' : '16px !important',
                sm: isChat || isInRibbon ? '16px !important' : '20px !important'
              },
              textAlign: 'left',
              wordBreak: 'break-word !important'
            }}
            children={
              el?.description && (
                <>
                  {!window.location.href.includes('post/') ? (
                    // ? el?.description
                    //     .slice(0, 165)
                    //     .split('\r\n')
                    //     .filter((el) => el.length !== 0)
                    //     .map((string, index) => {
                    //       return (
                    //         <React.Fragment key={index}>
                    //           <p className='postDescription' style={{ margin: '0', wordBreak: 'break-all !important'}}>
                    //             {string}
                    //             <br />
                    //           </p>
                    //         </React.Fragment>
                    //       );
                    //     })
                    <>
                      {el?.description.length > 220
                        ? el?.description.slice(0, 220).concat('...').split('\r\n')
                        : el?.description.slice(0, 220).split('\r\n')}
                      {!window.location.href.includes('post/') &&
                        el?.description &&
                        el?.description.length > 220 && (
                          <Typography
                            onClick={() => {
                              if (userData?.id) {
                                window.open(`${window.location.origin}/${language}/post/${el.id}`);
                              } else {
                                dispatch(setIsOpenAuthModal(true));
                              }
                            }}
                            sx={{
                              textAlign: 'right',
                              cursor: 'pointer',
                              marginTop: '0px',
                              marginLeft: '0px',
                              width: 'fit-content',
                              lineHeight: '20px',
                              fontSize: {
                                xs: isInRibbon ? '14px !important' : '16px !important',
                                sm: isChat || isInRibbon ? '16px !important' : '20px !important'
                              },
                              fontWeight: '400',
                              color: '#7C7C7C'
                            }}
                          >
                            {'Читати більше'}
                          </Typography>
                        )}
                    </>
                  ) : (
                    el?.description
                      // .slice(0, 165)
                      .split('\r\n')
                      .filter((el) => el.length !== 0)
                      .map((string, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Typography
                              className="postDescription"
                              sx={{
                                margin: '0',
                                wordBreak: 'break-word !important',
                                fontSize: { xs: '16px !important', sm: '20px !important' }
                              }}
                            >
                              {string}
                              <br />
                            </Typography>
                          </React.Fragment>
                        );
                      })
                  )}
                </>
              )
            }
          />

          <Stack
            direction="row"
            spacing={0}
            justifyContent="space-between"
            sx={{ mt: '24px', display: isChat ? 'none' : 'flex' }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {isWasLiked ? (
                <FavoriteIcon
                  onClick={() => {
                    if (userData?.id) {
                      if (
                        !blockedUsers.find(
                          (user) => user.id === el?.userDTO?.id || user.id === el?.userRibbonDTO?.id
                        )
                      ) {
                        if (!el?.isBlocked) {
                          apiAddLike
                            .updateDataQuery({ postId: el.id, isLikePost: false })
                            .then((res) => {
                              setLikesCount(likesCount - 1);
                              setIsWasLiked(false);
                            });
                        }
                      }
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  }}
                  sx={{
                    color: !el?.isBlocked ? 'red' : 'lightgray',
                    cursor: !el?.isBlocked ? 'pointer' : 'default'
                  }}
                />
              ) : (
                <FavoriteBorderIcon
                  onClick={() => {
                    if (userData?.id) {
                      if (
                        !blockedUsers.find(
                          (user) => user.id === el?.userDTO?.id || user.id === el?.userRibbonDTO?.id
                        ) &&
                        !usersWhoBlocked.find(
                          (user) => user === el?.userDTO?.id || user === el?.userRibbonDTO?.id
                        )
                      ) {
                        if (!el?.isBlocked) {
                          apiAddLike
                            .updateDataQuery({ postId: el.id, isLikePost: true })
                            .then((res) => {
                              setLikesCount(likesCount + 1);
                              setIsWasLiked(true);
                            });
                        }
                      }
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  }}
                  sx={{
                    ':hover': {
                      color: !el?.isBlocked ? 'red' : 'lightgray'
                    },
                    color: el?.isBlocked && 'lightgray',
                    cursor: !el?.isBlocked ? 'pointer' : 'default'
                  }}
                />
              )}
              {likesCount > 0 && (
                <Typography
                  sx={{
                    fontSize: { xs: '20px', sm: isChat ? '20px' : '24px' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    ml: '8px'
                  }}
                >
                  {likesCount}
                </Typography>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <ChatBubbleOutlineIcon
                sx={{
                  ':hover': {
                    color: !el?.isBlocked ? 'rgb(96, 165, 223)' : 'lightgray'
                  },
                  cursor: !el?.isBlocked ? 'pointer' : 'default',
                  color: el?.isBlocked && 'lightgray',
                  transform: 'scale(-1,1)'
                }}
                onClick={() => {
                  if (userData?.id) {
                    if (isHoverSelf) {
                      // navigate(`/${language}/post/${el.id}`);
                    } else {
                      // navigate(`/${language}/post/${el.id}`);
                      if (!el?.isBlocked) {
                        window.open(`${window.location.origin}/${language}/post/${el.id}`);
                      }
                    }
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
              />

              {!totalComments ? (
                <>
                  {el?.numberComments > 0 && (
                    <Typography
                      sx={{
                        ml: '8px',
                        fontSize: {
                          xs: '20px !important',
                          sm: isChat ? '20px' : '24px !important'
                        },
                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500'
                      }}
                    >
                      {el.numberComments}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography
                  sx={{
                    ml: '8px',
                    fontSize: { xs: '20px !important', sm: '24px !important' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500'
                  }}
                >
                  {totalComments}
                </Typography>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {' '}
              <IosShare
                onClick={() => {
                  if (userData?.id) {
                    if (!el?.isBlocked) {
                      dispatch(setIsOpenResendingModal({ isOpen: true, id: el.id, type: 'post' }));
                    }
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
                sx={{
                  ':hover': {
                    color: !el?.isBlocked ? 'rgb(96, 165, 223)' : 'lightgray',
                    cursor: !el?.isBlocked ? 'pointer' : 'default'
                  },
                  color: el?.isBlocked && 'lightgray',
                  width: '24px',
                  height: '24px'
                }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {' '}
              {userData &&
              userSavedPosts &&
              userSavedPosts.length !== 0 &&
              userSavedPosts.includes(el.id) ? (
                <BookmarkIcon
                  onClick={() => {
                    if (userData?.id) {
                      if (!el?.isBlocked) {
                        apiSavePost.deleteItemQuery({ postId: el.id }).then((res) => {
                          const newArray = userSavedPosts.filter((id) => el.id !== id);
                          if (window.location.href.includes('saved')) {
                            dispatch(setUserData({ ...userData, savedPosts: newArray }));
                            dispatch(setUserSavedPosts([...newArray]));
                          } else {
                            dispatch(setUserSavedPosts([...newArray]));
                          }
                        });
                      }
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  }}
                  sx={{
                    color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                    ':hover': {
                      color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                      cursor: !el?.isBlocked ? 'pointer' : 'default'
                    }
                  }}
                />
              ) : (
                <BookmarkBorderIcon
                  onClick={() => {
                    if (userData?.id) {
                      if (!el?.isBlocked) {
                        apiSavePost.updateDataQueryPost({ postId: el.id }).then((res) => {
                          const newArray = [...userSavedPosts, el.id];
                          if (window.location.href.includes('saved')) {
                            dispatch(setUserData({ ...userData, savedPosts: newArray }));
                            dispatch(setUserSavedPosts([...newArray]));
                          } else {
                            dispatch(setUserSavedPosts([...newArray]));
                          }
                        });
                      }
                    } else {
                      dispatch(setIsOpenAuthModal(true));
                    }
                  }}
                  sx={{
                    color: el?.isBlocked && 'lightgray',
                    ':hover': {
                      color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                      cursor: !el?.isBlocked ? 'pointer' : 'default'
                    }
                  }}
                />
              )}
            </div>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers,
    usersWhoBlocked: state.global.usersWhoBlocked
  };
};
export default connect(mapStateToProps)(PostCard);
